import React from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Security from "../LaunchpadHome/SubFooter";
import { FaEnvelope } from "react-icons/fa";
import { CiGlobe } from "react-icons/ci";

export default function TermsCondition() {
  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="privacypolicy py-5 ">
          <Container>
            <Row>
              <Col lg={12}>
                <div>
                  <div className="position-relative text-white">
                    <div className="mb-4 pb-1">
                      <h1 className="text-white mb-3">Terms and Conditions</h1>

                      <p className="text-light-grey">
                        <span className="text-white">Effective Date:</span>{" "}
                        June 23, 2025
                      </p>

                      <p className="text-light-grey">
                        Please read these Terms and Conditions ("Terms") carefully before using the <strong className="text-white">INFI MultiChain
                          CDEX Layer</strong>. By accessing or interacting with this decentralised system, you acknowledge and
                        agree to be bound by these Terms. If you do not agree with any part of the Terms, you should not
                        engage with the platform.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">1. Platform Overview</h5>
                      <p className="text-light-grey">
                        The INFI MultiChain CDEX Layer ("we", "our", "the Layer") operates as a decentralised,
                        community-coordinated smart contract environment. The system and its native utility token, INFI,
                        are governed by protocol-based logic within the community-developed ©SbSe Protocol framework.
                      </p>
                      <p className="text-light-grey">
                        This Layer is designed to enable peer-to-peer interaction of digital assets across supported
                        networks. No fiat integrations, traditional financial services, or custodial operations are involved.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">
                        2. Decentralised Participation
                      </h5>
                      <p className="text-light-grey">
                        To access certain platform features, users (MAY) are required to complete a minimal registration
                        process. This process includes:
                      </p>
                      <ul className="lh-lg text-light-grey">
                        <li><strong className="text-white">Email address</strong> (for optional communications)</li>
                        <li><strong className="text-white">Display name</strong></li>
                        <li><strong className="text-white">Self-custodied wallet address</strong></li>
                      </ul>
                      <p className="text-light-grey">
                        No personal identity documents or Know Your Customer (KYC) verification is required or
                        collected. The platform does <strong className="text-white">not</strong> request, store, or process any sensitive personal data.
                      </p>
                      <p>
                        All platform interactions are executed via decentralised smart contracts, and user data is <strong className="text-white">not stored
                          on any centralised servers.</strong> Participation is pseudonymous, and users retain full control of their
                        assets at all times.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">3. Non-Custodial Structure</h5>
                      <p className="text-light-grey">
                        The platform is fully non-custodial. It does <strong className="text-white">not:</strong>
                      </p>
                      <ul className="lh-lg text-light-grey">
                        <li>Store funds on behalf of users</li>
                        <li>Retain access to wallets or private keys</li>
                        <li>Intervene in user-held digital assets </li>
                      </ul>
                      <p className="text-light-grey">
                        Users retain complete control and responsibility over their wallets and actions.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">
                        4. On-Chain Parameters & System Logic
                      </h5>
                      <p className="text-light-grey">
                        All fee structures and protocol functions are managed on-chain by the SbSe Protocol. The protocol
                        may initiate logic-based distribution of utility acknowledgements for system participation. These
                        are automatically executed through smart contract rules and remain transparent to all participants.
                      </p>
                      <p className="text-light-grey">
                        ⚠ No part of this system provides or implies financial advice, investment guarantees, or returns.
                        Engagement with the platform is strictly utility-based and community-driven.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">
                        5. Communication Policy
                      </h5>
                      <p className="text-light-grey">
                        If provided, your email address may be used solely to:
                      </p>
                      <ul className="lh-lg text-light-grey">
                        <li>
                          Share platform updates{" "}
                        </li>
                        <li>Respond to inquiries </li>
                        <li>
                          Deliver optional content, which may be unsubscribed from at any time
                        </li>
                      </ul>
                      <p className="text-light-grey">
                        We do not sell or distribute contact information to third parties.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">6. Limitation of Liability</h5>
                      <p className="text-light-grey">
                        Due to the decentralised nature of the platform and its reliance on third-party blockchains and smart
                        contracts, users understand and agree that:
                      </p>
                      <ul className="lh-lg text-light-grey">
                        <li>
                          Use is entirely at your own discretion and risk
                        </li>
                        <li>We do not guarantee uptime, accuracy, or asset recoverability </li>
                        <li>
                          You are solely responsible for securing your wallet and data
                        </li>
                      </ul>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">7. No Fiat Currency or Custody Services</h5>
                      <p className="text-light-grey">This platform does not engage with any fiat currency, regulated banking operations, or custodial
                        asset management. All processes occur directly on-chain via user-controlled wallets.</p>

                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">8. Eligibility</h5>
                      <p className="text-light-grey">
                        By using the Layer, you confirm that:
                      </p>
                      <ul className="lh-lg text-light-grey">
                        <li>You are at least 18 years old</li>
                        <li>
                          You are legally permitted to use decentralised systems in your jurisdiction
                        </li>
                        <li>
                          You are not accessing the system from restricted or sanctioned regions
                        </li>
                      </ul>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">9.  Intellectual Property</h5>
                      <p className="text-light-grey">
                        All design elements, brand assets, and functional content within the INFI MultiChain CDEX Layer
                        are community-governed and protected under applicable creative frameworks. Reproduction
                        without permission is prohibited.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">10. Amendments</h5>
                      <p className="text-light-grey">
                        The community may update these Terms at any time through open governance. Changes will be
                        announced on the platform or via official communication channels. Continued usage implies
                        acceptance.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">11. General Disclaimer</h5>
                      <p className="text-light-grey">
                        The INFI MultiChain CDEX Layer is provided “as is” and “as available.” There are no guarantees
                        of platform performance, continuity, or user outcomes. Use is voluntary and self-directed.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">12. Contact</h5>
                      <p className="text-light-grey">
                        If you have questions about these Terms:
                      </p>
                      <ul className="lh-lg text-light-grey list-unstyled">
                        <li><span><FaEnvelope/></span>&nbsp;&nbsp;<strong className="text-white">Email :</strong> support@infimultichain.com </li>
                        <li><span><CiGlobe/></span>&nbsp;&nbsp;<strong className="text-white">Website :</strong> <a href="https://www.infimultichain.com/">https://www.infimultichain.com/</a></li>
                        <li><span><CiGlobe/></span>&nbsp;&nbsp;<strong className="text-white">Launchpad :</strong> <a href="https://launchpad.infimultichain.com/">https://launchpad.infimultichain.com/</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
